var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"picker-wrapper"},[_c('div',{staticClass:"btn btn-send",on:{"click":function($event){return _vm.togglePicker()}}},[_c('i',{staticClass:"far fa-smile"})]),_vm._v(" "),_c('picker',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPicker),expression:"showPicker"}],ref:"picker",staticClass:"picker",attrs:{"showSkinTones":false,"i18n":{
      search: 'Suchen',
      categories: { search: 'Ergebnis der Suche', recent: 'Letzte' }
    }},on:{"select":_vm.emit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }